export default __webpack_public_path__ + "static/media/2147.6d8f2be2.png";